import React from "react";

import TableItem from "../TableItem";

const UserTable = ({ userIds, onSelect, onShowUser }) => {
    return (
        <div>
            <table className="table is-hoverable is-fullwidth">
                <tbody>
                    {userIds.map(id => (
                        <TableItem
                            key={id}
                            userId={id}
                            onSelect={onSelect}
                            onShowUser={onShowUser}
                        ></TableItem>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default UserTable;
